module.exports = "/assets/4c210d653b21ac7a700231e8ff4a5ddf.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/CM.png
// module id = 1270
// module chunks = 0